import { Box, Grid, Skeleton, Typography } from '@mui/material';
import React from 'react';
import { PageContentDto } from '../../../services/dtos/page-content.dto';
import parse from 'html-react-parser';
import { roboto } from '../../../theme';

/**
 * Composant pour la RGPD, cgu, notice.
 * @constructor
 */
export default function InformationUi(props: { params: PageContentDto; loading: boolean }) {
    // Création de la page
    return (
        <Grid className="containerInformation" container spacing={6}>
            <Grid item xs={12} sx={{ textAlign: 'center', marginTop: '10px' }}>
                <Typography variant="h4" color="text.primary">
                    {props.loading ? <Skeleton /> : props.params.title}
                </Typography>
            </Grid>
            <Grid item xs={12}>
                <Box
                    sx={{
                        fontFamily: roboto,
                    }}
                >
                    {props.loading ? <Skeleton /> : parse(props.params.content as string)}
                </Box>
            </Grid>
        </Grid>
    );
}
